module.exports = __webpack_public_path__ + "media/images/logos/windeurope-annual-2022-a59b0201ece47d78fd377f1c3b14d44a.svg";